import { getCommentList } from '@/apis/zx.js';

export default {
  namespaced: true,
  state: () => {
    return {
      commentList: []
    };
  },
  mutations: {
    getCommentList (state, data) {
      state.commentList = data;
    }
  },
  actions: {
    async getCommentList ({ commit }) {
      try {
        const res = await getCommentList(20);
        if (+res._errCode === 0) {
          commit('getCommentList', res._data.list);
        }
      } catch (e) {
        console.log('getCommentList', e);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/comment/store.js